// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"5e3d2d0e","583":"00083f15","692":"dfbf3ed8"}[chunkId] + ".chunk.js";
};